import styled from "styled-components"
import { hw } from "features/homework/homeworkUi";

interface PermissionProps{
    input:{
        word:boolean,
        sentence:boolean,
        video:boolean,
    }
    onChange:(event: React.ChangeEvent<HTMLInputElement>) => void
}

const ReportPermission = ({input, onChange}:PermissionProps) => {
    return(
        <Container>
            <Label>컨텐츠 권한</Label>
            <Radios>
                <CheckBoxWrap>
                    <CheckBox id="word" type="checkbox" name="word"  onChange={onChange} checked={input.word}/>
                    <Option htmlFor="word">단어</Option>
                </CheckBoxWrap>
                <CheckBoxWrap>
                    <CheckBox id="sentence" type="checkbox" name="sentence"  onChange={onChange} checked={input.sentence}/>
                    <Option htmlFor="sentence">문장</Option>
                </CheckBoxWrap>
                <CheckBoxWrap>
                    <CheckBox id="video" type="checkbox" name="video"  onChange={onChange} checked={input.video}/>
                    <Option htmlFor="video">영상</Option>
                </CheckBoxWrap>
            </Radios>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const Label = styled.div`
    color: ${hw.text};
    font-size: 13px;
    font-weight: 600;
`

const Radios = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
`
const CheckBoxWrap = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px 12px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 8px;
`

const Option = styled.label`
    color: ${hw.text};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
`

const CheckBox = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${hw.brand};
    cursor: pointer;
`


export default ReportPermission;
